import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { fetchPartnerTransactions, selectCurrentClientType, selectCurrentPage, selectCurrentPartner, selectCurrentSearch, selectCurrentStore, selectEndDate, selectPartnerTransactionsFirstLoad, selectStartDate, setSelectedPartner, setSelectedStore } from "../model"
import { useEffect, useRef } from "react"
import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { PartnerTransactionsTable } from "./partner-transactions-table"
import { TransactionsFilters } from "./transactions-filters"
import { useSearchParams } from "react-router-dom"

export const PartnerTransactionsPage = () => {
    const isFirstRender = useRef(true)
    const [searchParams] = useSearchParams()
    const storeIdFromUrl = searchParams.get("storeId") || null
    const transactionsFirstLoad = useAppSelector(selectPartnerTransactionsFirstLoad)
    const page = useAppSelector(selectCurrentPage)
    const search = useAppSelector(selectCurrentSearch)
    const clientType = useAppSelector(selectCurrentClientType)
    const partnerId = useAppSelector(selectCurrentPartner)
    const startDate = useAppSelector(selectStartDate)
    const endDate = useAppSelector(selectEndDate)
    const storeId = useAppSelector(selectCurrentStore)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (
            storeIdFromUrl
            && partnerId?.length
            && (storeId?.[0] ?? null) !== storeIdFromUrl
        ) {
            dispatch(setSelectedPartner(null))
            dispatch(setSelectedStore(storeIdFromUrl))
            return
        }

        if ((storeId?.[0] ?? null) !== storeIdFromUrl) {
            dispatch(setSelectedStore(storeIdFromUrl))
        }
    }, [storeIdFromUrl])

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false

            if ((storeId?.[0] ?? null) !== storeIdFromUrl) {
                return
            }

            if (transactionsFirstLoad) {
                dispatch(fetchPartnerTransactions())
            }
            return
        }

        dispatch(fetchPartnerTransactions())
    }, [page, search, clientType, partnerId, storeId, startDate, endDate])

    return (
        <div className="_page_container">
            <PageHeader title="торговые точки" />
            <div className='flexbox'>
                <PageSubtitle title='транзакции' variant="acid" />
                <TransactionsFilters />
                <PartnerTransactionsTable />
            </div>
        </div>
    )
}
